import { FadeUp, MaskLines } from "./Reveal";

const INDUSTRIES = [
  "Travel",
  "Automobile",
  "Beauty",
  "Construction",
  "Healthcare",
  "Education",
  "Hospitality",
  "Real Estate",
  "Retail",
  "Logistics",
  "Finance",
  "Fitness & Wellness",
  "Food & Beverage",
  "Events & Entertainment",
  "Media",
  "Legal Services",
  "Manufacturing",
  "Interior Design",
  "Veterinary",
  "Sports",
];

function Row({ hidden }) {
  return (
    <div className="flex shrink-0 items-center gap-12 pr-12" aria-hidden={hidden || undefined}>
      {INDUSTRIES.map((ind) => (
        <span key={ind} className="flex items-center gap-12">
          <span className="whitespace-nowrap text-[clamp(3rem,5.5vw,4.5rem)] font-normal leading-none tracking-[-0.02em] text-[#0f0f14]">
            {ind}
          </span>
          <span className="h-2.5 w-2.5 rounded-full bg-brand" />
        </span>
      ))}
    </div>
  );
}

export default function Industries() {
  return (
    <section className="bg-paper py-24 text-[#0f0f14] md:py-28">
      <div className="mx-auto max-w-[1160px] px-6">
        <FadeUp>
          <p
            className="text-[13px] font-semibold uppercase tracking-[0.18em] text-brand"
            data-testid="industries-eyebrow"
          >
            07 — Industries
          </p>
        </FadeUp>

        <MaskLines
          lines={["Serving 20+ industries."]}
          className="mt-8 text-[clamp(2.5rem,5.4vw,4.6rem)] font-normal leading-[1.04] tracking-[-0.025em]"
        />
      </div>

      <div
        className="marquee mt-16 overflow-hidden border-y border-black/[0.08] py-10"
        data-testid="industries-marquee"
      >
        <div className="animate-marquee flex w-max" style={{ animationDuration: "80s" }}>
          <Row />
          <Row hidden />
        </div>
      </div>
    </section>
  );
}
